import Magnifier from 'react-image-magnify'

import { crunchSrcSet } from './utils'
import { PhotoProps } from '../../../shared/Module'

interface ZoomableImageProps extends PhotoProps {
  alt: string
  src: string
  className: string
}

const ZoomableImage = ({
  alt,
  className,
  sizes,
  src,
  srcset,
}: ZoomableImageProps) => {
  const maxUsefulSize = screen.width * 2
  const availableSizes = srcset.map(([_, desc]) => parseInt(desc, 10))
  const maxSize =
    availableSizes.find((size) => size >= maxUsefulSize) ||
    availableSizes[availableSizes.length - 1]
  const srcSet = crunchSrcSet(srcset)

  const smallImage = {
    alt,
    isFluidWidth: true,
    sizes,
    src,
    srcSet,
  }

  const largeImage = {
    alt,
    height: maxSize,
    src,
    srcSet,
    width: maxSize,
  }

  return (
    <Magnifier
      className={className}
      enlargedImagePosition='over'
      enlargedImageStyle={{ maxWidth: 'none' }}
      fadeDurationInMs={200}
      hoverDelayInMs={200}
      pressDuration={200}
      largeImage={largeImage}
      shouldHideHintAfterFirstActivation={false}
      smallImage={smallImage}
    />
  )
}

export default ZoomableImage
